import { GlobalFooter, GlobalHeader } from '../components'
import Style from './index.module.css'

const Yendo = () => {
    return (
        <>
            <GlobalHeader />
            <div className="cure-inner-container">
                <div className={Style['container']}>
                    <div className={`${Style['headerContainer']} ${Style['centerTxt']}`}>
                        <div className={Style['logoContainer']}>
                            <a href='https://www.yendo.com/?channel=cure&utm_campaign=DL' target='_blank'>
                                <img className={`${Style['logoImg']} ${Style['fullRounded']}`} alt='Yendo Logo' src="https://assets.cure.com/img/main-site/Orange%20Yendo%20Logo.png" />
                            </a>
                        </div>

                        <div className={Style['headerTxtContainer']}>
                            <strong>Turn your car’s equity into spending power!</strong>
                            <p>You may be eligible for a secured credit card from <br/>Yendo based on your car’s value.</p>
                        </div>

                        <div className={Style['logoContainer']}>
                            <img className={Style['fullRounded']} style={{ width: '100%' }} alt='Yendo Image' src="https://assets.cure.com/img/main-site/Highlights%20Blue%20Image.png" />
                        </div>

                        <a className={Style['applyBtn']} href='https://www.yendo.com/?channel=cure&utm_campaign=DL' target='_blank'>
                            Apply Now
                        </a>
                    </div>

                    <div className={Style['infoCardContainer']}>
                        <div className={Style['centerTxt']}>
                            <strong>What you’ll get from Yendo</strong>
                        </div>

                        <div>
                            <ListItems list={[
                                { title: 'A financial option based on your vehicle’s value', item: 'Turn your car’s equity into spending power with higher limits at affordable rates.' },
                                { title: 'Credit limits up to $10,000', item: 'Financial support for unexpected vehicle expenses and more.' },
                                { title: 'Fast access to credit', item: 'Quick decision, plus a virtual card before your physical card arrives.' },
                                { title: 'No impact to credit for pre-approval decision', item: 'Check for your offer quickly without affecting your credit score. Responsible use can help build credit.' },
                            ]} />
                        </div>
                    </div>

                    <div className={Style['bottomContainer']}>
                        <div className={Style['cardImgContainer']}>
                            <img alt='Yendo Card Top' className={`${Style['topRounded']} ${Style['cardImg']}`} src="https://assets.cure.com/img/main-site/Yendo%20Card%20Top%20Image.png" />
                        </div>

                        <div className={Style['bottomCard']}>
                            <div className={Style['cardImgContainer']}>
                                <img alt='Yendo Card Bottom' className={`${Style['bottomRounded']} ${Style['cardImg']}`} src="https://assets.cure.com/img/main-site/Yendo%20Card%20Bottom%20Image.png" />
                            </div>

                            <div className={Style['featuredImgContainer']} >
                                <img alt='Yendo Featured' src="https://assets.cure.com/img/main-site/Featured%20In%20Image.jpg" />
                            </div>

                            <div className={Style['bottomCardTxtContainer']}>
                                <p>
                                    Yendo credit cards are issued by Cross River Bank, Member FDIC, pursuant to license from Mastercard International. © 2026 Yendo, Inc. All rights reserved.
                                </p>
                                <p>
                                    *Unlimited 1.5% cash back is earned as a statement credit on eligible purchases when automatic payments (autopay) are enabled. Cash back terms, eligibility, and exclusions may apply.
                                </p>
                                <p>
                                    *Based on internal reporting, many customers are able to complete the pre-approval process in approximately one minute. Pre-approval timing may vary.
                                </p>
                                <p>
                                    CURE auto insurance is not a bank, lender, or credit card issuer. Yendo credit cards are issued and managed solely by Yendo and its banking partners. This is a general offer, not an exclusive CURE discount. Applying for or maintaining a Yendo card is not required to purchase or keep a CURE policy and will not affect your insurance rates. By clicking “Apply Now,” you agree to be redirected to Yendo and allow CURE to share certain contact and vehicle information with Yendo under our joint marketing and privacy policies.
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <GlobalFooter />
        </>
    )
}

const ListItems = ({ list }) => {
    return (
        <ul className={Style['checkList']}>
            {list.map((val, idx) => (
                <li key={idx}>
                    <div>
                        <strong className={Style['title']}>{val.title}</strong>
                        <div>{val.item}</div>
                    </div>
                </li>
            ))}
        </ul>
    )
}

Yendo.propTypes = {}

export default Yendo
